export default __webpack_public_path__ + "static/media/icon7.2b4eb520.png";